import { TypedUseSelectorHook, useSelector } from "react-redux";
import useFetch from "../../../../hooks/useFetch";
import { RootState } from "../../../../redux/reducers";
import { FormulaireDePaiement } from "../../../../services/Api/swagger";

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;

export const usePaiementEnLigne = (
  numeroAdhesion,
  disabledRenouvellement,
  renouvellement
) => {
  const {
    response: formulairePaiement,
    fetching: fetchingPaiement,
    error: errorPaiement,
  } = useFetch<FormulaireDePaiement>(
    numeroAdhesion,
    "postPaiementEnLigne",
    numeroAdhesion &&
      !disabledRenouvellement &&
      renouvellement &&
      renouvellement.numeroAdhesion === numeroAdhesion
  );

  return {
    formulairePaiement,
    fetchingPaiement,
    errorPaiement,
  };
};
